import type { HttpPort } from "~/lib/http";

export interface TeacherProfile {
  firstName: string;
  lastName: string;
  email: string;
  schoolName: string;
}

export interface PasswordChange {
  currentPassword: string;
  newPassword: string;
  confirmation: string;
}

export function createSettingsModule(http: HttpPort, token: string) {
  return {
    async load(): Promise<TeacherProfile> {
      const result = await http.request<{ profile: TeacherProfile }>({ path: "/settings", token });
      return result.profile;
    },
    async saveProfile(profile: TeacherProfile): Promise<TeacherProfile> {
      const normalized = {
        firstName: profile.firstName.trim(),
        lastName: profile.lastName.trim(),
        email: profile.email.trim(),
        schoolName: profile.schoolName.trim()
      };
      if (!normalized.firstName || !normalized.lastName) throw new Error("Vor- und Nachname erforderlich.");
      if (!normalized.email) throw new Error("E-Mail erforderlich.");
      const result = await http.request<{ profile: TeacherProfile }>({
        path: "/settings/profile",
        method: "PATCH",
        token,
        body: { ...normalized, schoolName: normalized.schoolName || null }
      });
      return result.profile;
    },
    async changePassword(input: PasswordChange): Promise<void> {
      if (!input.currentPassword || !input.newPassword || !input.confirmation) throw new Error("Alle Felder ausfüllen.");
      if (input.newPassword.length < 8) throw new Error("Neues Passwort muss mindestens 8 Zeichen haben.");
      if (input.newPassword !== input.confirmation) throw new Error("Passwörter stimmen nicht überein.");
      await http.request({
        path: "/settings/password",
        method: "PATCH",
        token,
        body: { currentPassword: input.currentPassword, newPassword: input.newPassword }
      });
    }
  };
}

export type SettingsModule = ReturnType<typeof createSettingsModule>;
